<template>
    <button
        :type="type"
        :class="[ //mr-2 md:ml-2 md:mr-0 (removido)
            'inline-flex items-center px-3 py-2 justify-center',
            'border border-transparent',
            'text-sm leading-4 font-medium text-white',
            'rounded-xl chat_transition',
            `${useSize()}`,
            `${useColor()} shadow-lg hover:shadow-none`,
            {'shadow-chat-primary chat_shadow': useColor() === 'btn_pattern'},
            `focus:outline-none focus:shadow-none focus:ring-2 focus:ring-offset-gray-100 focus:ring-offset-2 focus:ring-chat-primary`,
            'disabled:shadow-none disabled:cursor-no-drop disabled:opacity-50',
            'dark:focus:ring-offset-neutral-700',
        ]"
        :disabled="loading || disabled"
        :title="titleButton"
        @click="execAction"
    >
        <Unicon
            v-if="icon && !loading"
            :name="icon"
            class="-ml-0.5 h-4 w-4 "
            :class="{ 'mr-1': content !== ''}"
            aria-hidden="true"
        />

        <Icon v-if="iconify && !loading"
            class="-ml-0.5 h-5 w-5 "
            :class="{ 'mr-1': content !== ''}"
            :icon="iconify"
            aria-hidden="true"
        />

        <template v-if="loading">
            <svg
                class="animate-spin -ml-0.5 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                />
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
            </svg>
        </template>

        <span
            :class="{'hidden md:block ml-2': hiddenMdText}"
        >
            {{ content }}
        </span>
    </button>
</template>

<script>
import { Icon } from '@iconify/vue'

    export default {
        components: { Icon },
        name: 'ButtonForm',
        props: {
            hiddenMdText: {
                type: Boolean,
                default: false,
            },
            content: {
                type: String,
                required: true,
            },
            icon: {
                type: String,
                default: null,
            },
            iconify: {
                type: String,
                default: null,
            },
            color: {
                type: String,
                default: 'primary',
            },
            type: {
                type: String,
                default: 'button',
            },
            titleButton: {
                type: String,
                default: '',
            },
            action: {
                type: Object,
                default: null,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'md',
            },
        },

        emits: ['buttonAction'],
        methods: {
            useSize(){
                const defaults = {


                    'xs' : 'px-2 py-1 text-xs',
                    'sm' : 'px-2 py-1 text-sm',
                    'md' : 'px-2.5 py-1.5 text-sm',
                    'lg' : 'px-3 py-2 text-sm',
                    'xl' : 'px-3.5 py-2.5 text-sm'
                }

                return defaults[this.size] || 'sm';

            },
            useColor() {
                const defaults = {
                    'primary': 'btn_pattern',
                    'green': 'btn_green',
                    'gray': 'btn_gray',
                    'blue': 'btn_blue',
                    'yellow': 'btn_yellow',
                    'red': 'btn_red',
                    'white' : 'btn_white',
                }

                return defaults[this.color] || 'btn_gray';
            },

            execAction() {
                if (this.type !== 'submit'){
                    event.preventDefault()
                    event.stopPropagation()
                }

                if (this.action?.exec) {
                    this.$emit('buttonAction', this.action)
                } else if (this.action?.to) {
                    this.$router.push({name: this.action.to})
                } else if (this.action?.refresh){
                    this.$router.go(0)
                }
            },
        },
    }
</script>

<style scoped>
.btn_primary, .btn_pattern {
  @apply bg-chat-primary;
  @apply focus:ring-chat-primary;
}

.btn_white {
    @apply bg-white  text-slate-600;

}
.btn_green {
  @apply bg-green-600;
  @apply shadow-green-500/30 focus:ring-green-500;
}

.btn_blue {
  @apply bg-blue-500;
  @apply shadow-blue-500/30 focus:ring-blue-500;
}

.btn_red {
    @apply bg-red-500;
    @apply shadow-red-500/30 focus:ring-red-500;
}

.btn_yellow {
    @apply bg-yellow-400;
    @apply shadow-yellow-500/30 focus:ring-yellow-500;
}

.btn_gray {
  @apply bg-gray-200 bg-opacity-70 text-gray-500 shadow-none;
  @apply hover:bg-gray-200 focus:ring-gray-200 focus:bg-gray-200;
  @apply dark:bg-neutral-500 dark:text-gray-300;
  @apply dark:hover:bg-neutral-700 dark:hover:bg-opacity-50;
  @apply dark:focus:bg-neutral-700 dark:focus:bg-opacity-50 dark:focus:ring-neutral-700;
}
</style>
